export default "__VITE_ASSET__A$caSExG__"